import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { Row, Col, Card } from "react-bootstrap";
import { motion } from "framer-motion";

export default function Ekstrakurikuler() {
  const [ekstraList, setEkstraList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEkstra = async () => {
      try {
        const q = query(
          collection(db, "ekstrakurikuler"),
          orderBy("nama", "asc")
        );
        const snap = await getDocs(q);
        const data = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setEkstraList(data);
      } catch (err) {
        console.error("fetch ekstrakurikuler error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEkstra();
  }, []);

  if (loading)
    return (
      <p className="text-center mt-4">
        Memuat kegiatan ekstrakurikuler...
      </p>
    );

  if (ekstraList.length === 0)
    return (
      <p className="text-center mt-4">
        Belum ada kegiatan ekstrakurikuler.
      </p>
    );

  return (
    <section
      className="py-5 ekstrakurikuler-section"
      style={{
        background:
          "linear-gradient(to bottom, #ffffff 0%, #e8f1ff 50%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-5 text-center"
          style={{ color: "#0d47a1" }}
        >
          Ekstrakurikuler
        </h2>

        <Row className="g-4">
          {ekstraList.map((e, idx) => (
            <Col key={e.id} xs={12} sm={6} md={4} lg={3}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.12 }}
              >
                <Card
                  className="h-100 border-0 shadow-sm ekstrakurikuler-card"
                  style={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    transition: "all 0.35s ease",
                  }}
                >
                  <div style={{ overflow: "hidden" }}>
                    <Card.Img
                      variant="top"
                      src={e.gambar || "/assets/ekstra-placeholder.png"}
                      alt={e.nama}
                      style={{
                        height: "220px",
                        objectFit: "cover",
                        transition: "transform 0.5s ease",
                      }}
                    />
                  </div>

                  <Card.Body
                    className="text-center p-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff, #f1f6ff)",
                    }}
                  >
                    <Card.Title
                      className="fw-semibold mb-2"
                      style={{ color: "#1b5e20" }}
                    >
                      {e.nama}
                    </Card.Title>

                    {e.deskripsi && (
                      <Card.Text className="text-muted small">
                        {e.deskripsi.length > 100
                          ? e.deskripsi.substring(0, 100) + "..."
                          : e.deskripsi}
                      </Card.Text>
                    )}

                    {e.jadwal && (
                      <span
                        className="badge mt-2"
                        style={{
                          background:
                            "linear-gradient(90deg, #1b5e20, #0d47a1)",
                          color: "#fff",
                        }}
                      >
                        {e.jadwal}
                      </span>
                    )}
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Hover effect khusus */}
      <style>
        {`
          .ekstrakurikuler-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 14px 30px rgba(0,0,0,0.15);
          }

          .ekstrakurikuler-card:hover img {
            transform: scale(1.08);
          }
        `}
      </style>
    </section>
  );
}
